import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import React from "react";

const CustomModal = (props) => {
    const { modalTitle, modalText, confirmText, cancelText, show, handleClose, handleHide, handleConfirm, handleCancel, style } = props;
    const handleCloseModal = (type, data) => {
        handleClose();
        switch (type) {
            case 'confirm':
                if (handleConfirm) {
                    handleConfirm(data);
                }
                break;
            case 'cancel':
                if (handleCancel) {
                    handleCancel(data);
                }
                break;
            case 'hide':
            default:
                if (handleHide) {
                    handleHide(data);
                }
        }
    }
    const modalTextIsComponent = typeof modalText === 'object';
    return (
        <>
            <Modal style={style ? style : null} show={show} onHide={(data) => handleCloseModal('hide', data)} centered>
                {modalTitle && <Modal.Header closeButton>
                                <Modal.Title>{modalTitle}</Modal.Title>
                            </Modal.Header>}
                <Modal.Body>{
                    modalTextIsComponent ?
                        React.createElement(modalText, { confirmAction: (data) => {
                            handleCloseModal('confirm', data)
                        }, cancelAction: (data) => {
                            handleCloseModal('cancel', data)
                        }}) :
                        modalText}
                </Modal.Body>
                {
                    (confirmText || cancelText) &&
                    <Modal.Footer>
                        {confirmText && <Button variant="primary" onClick={(data) => handleCloseModal('confirm', data)}>
                            {confirmText}
                        </Button>}
                        {cancelText && <Button variant="secondary" onClick={(data) => handleCloseModal('cancel', data)}>
                            {cancelText}
                        </Button>}
                    </Modal.Footer>
                }
            </Modal>
        </>
    );
}

export default CustomModal;
